export default __webpack_public_path__ + "static/media/trash-icon-white.6fea4672.svg";